import { useTranslation } from 'react-i18next';

export default function Splash() {
  const { t } = useTranslation();
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'var(--surface)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        className="sls-logo-clean"
        style={{
          width: 120,
          height: 120,
          backgroundColor: 'var(--line)',
          borderRadius: 20,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: 16,
          overflow: 'hidden',
        }}
      >
        <img src="/icons/icon-512.png" alt="" style={{ width: 100, height: 100, objectFit: 'contain' }} />
      </div>
      <div style={{ color: 'var(--ink)', fontSize: 32, fontWeight: 900, letterSpacing: 2 }}>{t('app.name')}</div>
      <div style={{ color: 'var(--muted)', fontSize: 14, fontWeight: 500, marginTop: 4 }}>{t('app.tagline')}</div>
      <div
        style={{
          marginTop: 32,
          width: 36,
          height: 36,
          border: '4px solid var(--line)',
          borderTopColor: '#00d632',
          borderRadius: '50%',
          animation: 'sls-spin 1s linear infinite',
        }}
      />
      <style>{`@keyframes sls-spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
